<template>
  <div id="Software">
    <!-- <img
      src="@/assets/images/pic2.svg"
      style="width: 100%; height: auto"
      alt=""
    /> -->
    <div class="flex">
      <div>
        <img
          src="@/assets/images/pic200-19.svg"
          style="
            width: 100%;
            max-width: 624px;
            height: auto;
            margin-right: 40px;
          "
          alt=""
        />
      </div>
    </div>
    <div class="text" style="margin-top: 20px">
      通过医疗数据集成平台，承担数据和消息的通讯和传输功能，对平台所有消息队列、服务数、服务交互流程、服务异常等状态等进行监控可视化、统一界面管理，使得医院对所有业务系统接口管理更具有控制权，实现各个业务系统间的接口改造，统一内部数据交互中的数据标准。以“集成、互融、数据多维度应用”为目标，打破当前医院“点对点”的接口模式，让所有厂商的系统与医疗数据集成平台进行对接，保证各个业务信息系统进行维护或升级改造时不会发生连锁反应，大幅减少信息化发展的成本。
    </div>
  </div>
</template>
<script>
export default {
  name: "Software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-right: 40px;
  text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution2.vue